// Inbox → extraction-pipeline routing — API client.
// Backend: app/routes/intake_routing.py (/api/admin/intake/*).

import api from './api';

export interface Pipeline {
  key: string;
  label: string;
  kb_server_id: string;
  kb_label: string;
  description: string;
  extractor_ready: boolean;
}

export interface Inbox {
  id: string;
  email: string;
  display_name: string | null;
  purpose: string;
  status: string;
  pipeline_keys: string[];
}

export interface RoutingGraph {
  inboxes: Inbox[];
  pipelines: Pipeline[];
}

export interface RouteResult {
  ok: boolean;
  email_account_id: string;
  pipeline_key: string;
}

const BASE = '/admin/intake';

export const intakeRoutingApi = {
  graph: async (): Promise<RoutingGraph> => {
    const r = await api.get<RoutingGraph>(`${BASE}/routing-graph`);
    return r.data;
  },

  pipelines: async (): Promise<Pipeline[]> => {
    const r = await api.get<Pipeline[]>(`${BASE}/pipelines`);
    return r.data;
  },

  addRoute: async (
    emailAccountId: string,
    pipelineKey: string,
  ): Promise<RouteResult> => {
    const r = await api.put<RouteResult>(`${BASE}/routes`, {
      email_account_id: emailAccountId,
      pipeline_key: pipelineKey,
    });
    return r.data;
  },

  removeRoute: async (
    emailAccountId: string,
    pipelineKey: string,
  ): Promise<RouteResult> => {
    const r = await api.delete<RouteResult>(`${BASE}/routes`, {
      data: { email_account_id: emailAccountId, pipeline_key: pipelineKey },
    });
    return r.data;
  },
};
